import React from 'react';

import { ButtonProps, Typography } from '@mui/material';

import { StyledSubmitButton } from './styles';

function SubmitButton({ label, ...rest }: { label: string } & ButtonProps) {
	return (
		<StyledSubmitButton fullWidth type="submit" variant="contained" color="primary" {...rest}>
			<Typography variant={'subtitle1'}>
				<b>{label}</b>
			</Typography>
		</StyledSubmitButton>
	);
}

export default SubmitButton;
